import React from "react";
import AdminSidebar from "../../modules/auth0/sidebar/AdminSidebar";
import Footer from "../footer";
import AffiliateSidebar from "../../modules/auth0/sidebar/AffiliateSidebar";
import TopNavBar from "../topNavBar";
/** @jsxImportSource theme-ui */

const Layout = ({ children }) => {
  const admin = localStorage.getItem("profile");
  const [showSideBar, setShowSideBar] = React.useState(false);

  return (
    <>
      <div className="w-full flex min-h-screen">
        <div className={`md:block hidden sticky top-0 h-[100vh] w-[23%]`}>
          {admin === "standardAffiliate" ? <AffiliateSidebar toggleSidebar={() => setShowSideBar(!showSideBar)} /> : <AdminSidebar toggleSidebar={() => setShowSideBar(!showSideBar)} />}
        </div>

        <div className={`${showSideBar ? "w-[60%] sm:w-[35%]  block md:hidden" : "hidden"}  fixed z-20 top-0 h-[100vh]`}>
          {admin === "standardAffiliate" ? <AffiliateSidebar toggleSidebar={() => setShowSideBar(!showSideBar)} /> : <AdminSidebar toggleSidebar={() => setShowSideBar(!showSideBar)} />}
        </div>

        <div className={` md:w-[77%] w-full h-full`}>
          <TopNavBar toggleSidebar={() => setShowSideBar(!showSideBar)} />
          <div className="py-1 px-5 min-h-[calc(100vh_-_132px)] relative bg-[#EEE]">
            {children}
          </div>
          <footer className="bg-white shadow  sticky bottom-0 z-10 ">
            <Footer />
          </footer>
        </div>
      </div>
    </>
  );
};

export default Layout;
